/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-controls-pause-outline-filled': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M10 1.25a8.75 8.75 0 100 17.5 8.75 8.75 0 000-17.5zm-1.25 12.5H7.5v-7.5h1.25v7.5zm3.75 0h-1.25v-7.5h1.25v7.5z"/>'
  }
})
